import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { connect } from 'react-redux'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import { userActions } from '../../redux/actions'
import { userService } from '../../services'

const ResendEmailVerificationCode = ({ user, className }) => {
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)

  const resendEmailCode = () => {
    setLoading(true)
    userService
      .resendVerifyEmailCode()
      .then(() => setShowModal(true))
      .finally(() => setLoading(false))
  }

  const toggleModal = () => {
    setShowModal(!showModal)
  }

  // Unique IDs for accessibility
  const modalId = 'email-verification-modal'
  const modalTitleId = 'email-verification-title'

  return (
    <div className="email-verification-container">
      <div className="my-3">
        {loading ? (
          <span aria-live="polite">
            <FormattedMessage id="global.label.sending" />
            ...
          </span>
        ) : (
          <button
            type="button"
            className="btn btn-link p-0 text-left"
            onClick={resendEmailCode}
            aria-label="Resend email verification code"
          >
            <FormattedMessage id="global.label.resendEmailCode" />
          </button>
        )}
      </div>

      <Modal
        isOpen={showModal}
        toggle={toggleModal}
        className={className}
        size="lg"
        id={modalId}
        aria-labelledby={modalTitleId}
        role="dialog"
      >
        <ModalHeader toggle={toggleModal}>
          <span className="sr-only">
            <FormattedMessage id="global.label.close" defaultMessage="Close" />
          </span>
        </ModalHeader>
        <ModalBody>
          <h2 id={modalTitleId} className="text-center">
            <FormattedMessage id="page.activationPage.emailActivationSent.title" />
          </h2>
          <p>
            <FormattedMessage
              id="page.activationPage.emailActivationSent.description"
              values={{ email: user.email }}
            />
          </p>
        </ModalBody>
        <ModalFooter>
          <div className="w-100">
            <div className="row">
              <div className="col">
                <Button
                  block
                  outline
                  color="light"
                  onClick={toggleModal}
                  aria-label="Close this message"
                >
                  OK
                </Button>
              </div>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  )
}

ResendEmailVerificationCode.propTypes = {
  user: PropTypes.object.isRequired,
  className: PropTypes.string,
}

ResendEmailVerificationCode.defaultProps = {
  className: '',
}

const { resendVerifyEmailCode } = userActions
const ConnectedComponent = connect(null, { resendVerifyEmailCode })(ResendEmailVerificationCode)

export default ConnectedComponent
